var _effectorFileName = "/builds/gmini/front-common/src/components/VersionSwitch/VersionHistory.tsx";
import React from 'react';
import { RoundedCross, Tooltip } from '@gmini/ui-kit';
import arrowIcon from "./icons/arrowIcon.svg";
import { Backdrop, Divider, ListHeader, Paper, Title, ToLastVersionButton, ToLastVersionButtonIcon, ToLastVersionButtonInnerWrap, ToLastVersionButtonText, ToLastVersionWrap, CloseButton, BeforeListWrap } from "./VersionHistory.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var VersionHistory = /*#__PURE__*/React.memo(function (_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onRedirectToLast = _ref.onRedirectToLast,
      isCurrentVersion = _ref.isCurrentVersion,
      versionList = _ref.versionList,
      beforeList = _ref.beforeList;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [open && /*#__PURE__*/_jsx(Backdrop, {
      onClick: onClose
    }), /*#__PURE__*/_jsxs(Paper, {
      open: open,
      children: [/*#__PURE__*/_jsxs(ListHeader, {
        children: [/*#__PURE__*/_jsx(Title, {
          children: "\u0421\u043F\u0438\u0441\u043E\u043A \u0432\u0435\u0440\u0441\u0438\u0439"
        }), /*#__PURE__*/_jsx(CloseButton, {
          type: "square",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(RoundedCross, {})
        })]
      }), /*#__PURE__*/_jsx(BeforeListWrap, {
        children: beforeList
      }), versionList, /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ToLastVersionWrap, {
        children: /*#__PURE__*/_jsx(Tooltip, {
          arrow: true,
          style: {
            zIndex: 1
          },
          title: isCurrentVersion ? 'Вы находитесь на последней версии' : '',
          children: /*#__PURE__*/_jsx(ToLastVersionButton, {
            "data-test-id": "moveToLastVersion",
            disabled: isCurrentVersion,
            onClick: function onClick() {
              if (!isCurrentVersion) {
                onRedirectToLast();
              }
            },
            children: /*#__PURE__*/_jsxs(ToLastVersionButtonInnerWrap, {
              children: [/*#__PURE__*/_jsx(ToLastVersionButtonIcon, {
                src: arrowIcon
              }), /*#__PURE__*/_jsx(ToLastVersionButtonText, {
                children: "\u041A \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0439 \u0432\u0435\u0440\u0441\u0438\u0438"
              })]
            })
          })
        })
      })]
    })]
  });
});
VersionHistory.displayName = 'VersionHistory';